import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Form } from './Pages/forms/form';
import './style.css';
import { Routes, Route, HashRouter, BrowserRouter } from 'react-router-dom';
import store from './redux/store';
import { Provider } from 'react-redux';
import { GlobalStyle } from './fonts/fonts';
import About from './Pages/About/About';

// -- cargar aqui nuevos trabajos individuales. -------------------

// import Work_Individual_Arkitema from './Pages/Stories/Individual/WorkIndividual_Arkitema';

import { gsap } from 'gsap'; // Importar GSAP

//const TRACKING_ID = "G-RBZ079NC5M"; // YOUR_OWN_TRACKING_ID

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <GlobalStyle />
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomeWithAnimation />} />
        <Route path="Form" element={<Form />} />
        <Route path="About" element={<AboutWithAnimation />} />
        <Route path="VelaViento" element={<VelaVientoWithAnimation />} />
        <Route path="Graton" element={<GratonWithAnimation />} />
        {/*path es el nombre de acceso (el link sobre el sitio), y element es el nombre del componente*/}
        {/* <Route path="Work/Arkitema" element={<Work_Individual_Arkitema />} /> */}
      </Routes>
    </HashRouter>
  </Provider>
);

function GalleryImagesWithAnimation() {
  // En esta función, configuramos las animaciones de entrada y salida de la página "GalleryImages"
  // utilizando GSAP.

  // Animación de entrada al montar el componente
  React.useEffect(() => {
    gsap.fromTo('.page', { opacity: 0 }, { opacity: 1, duration: 1 });
  }, []);

  // Animación de salida al desmontar el componente
  React.useEffect(() => {
    return () => {
      gsap.to('.page', { opacity: 0, duration: 1 });
    };
  }, []);

  // Renderizamos el componente "GalleryImages" con una clase "page" para aplicar las animaciones.
  return (
    <div className="page">
      <GalleryImages />
    </div>
  );
}

function HomeWithAnimation() {
  const pageRef = React.useRef(null);

  React.useEffect(() => {
    if (pageRef.current) {
      gsap.fromTo(pageRef.current, { opacity: 0 }, { opacity: 1, duration: 1 });
    }
  }, []);

  return (
    <div ref={pageRef} style={{ width: '100%' }}>
      <App />
    </div>
  );
}

function AboutWithAnimation() {
  const pageRef = React.useRef(null);
  React.useEffect(() => {
    if (pageRef.current) {
      gsap.fromTo(pageRef.current, { opacity: 0 }, { opacity: 1, duration: 1 });
    }
  }, []);

  return (
    <div ref={pageRef} className="page">
      <About />
    </div>
  );
}

import VelaViento from './Pages/Home/VelaViento';

function VelaVientoWithAnimation() {
  const pageRef = React.useRef(null);

  React.useEffect(() => {
    if (pageRef.current) {
      gsap.fromTo(pageRef.current, { opacity: 0 }, { opacity: 1, duration: 1 });
    }
  }, []);

  return (
    <div ref={pageRef} className="page">
      <VelaViento />
    </div>
  );
}

import Graton from './Pages/Home/Graton';

function GratonWithAnimation() {
  const pageRef = React.useRef(null);

  React.useEffect(() => {
    if (pageRef.current) {
      gsap.fromTo(pageRef.current, { opacity: 0 }, { opacity: 1, duration: 1 });
    }
  }, []);

  return (
    <div ref={pageRef} className="page">
      <Graton />
    </div>
  );
}
